export default "__VITE_ASSET__DMzhBPli__"